import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import {Button, DescriptiveText, Row, TextInput} from '../../../../shared';
import axiosInstance from '../../../utils/axios';
import {_setNotification} from '../../../reducers/headerNotification';
import CreatePassword from '../../../widgets/CreatePassword';

function ChangePasswordModal(props) {
  const {content, openModal, removeModal, setNotification} = props;
  const [password, setPassword] = useState({});
  const [oldPassword, setOldPassword] = useState('');

  const updatePassword = (name, value) => setPassword(current => ({...current, [name]: value}));

  const updateOldPassword = (name, value) => setOldPassword(value);

  const submit = e => {
    e.preventDefault();
    return axiosInstance.put('/user/password', {password: {new: password.password, old: oldPassword}})
      .then(() => {
        setNotification({message: 'Your password has been updated.'});
        removeModal(content);
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.code === 100) {
          setOldPassword('');
          return openModal({
            type: 'MessageModal',
            title: 'Incorrect Password',
            body: 'The old password is incorrect',
          });
        }
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.code === 201) {
          return openModal({
            type: 'MessageModal',
            title: 'Weak Password',
            body: 'The password isn\'t strong enough, it must be between 8 and 20 characters long,\n\ ' // ETODO Password Reqs
              + 'include at least 1 number, uppercase, and lowercase letter.\n\ '
              + 'It must also include at least 1 of the following symbols !@#$%^&*?_~',
          });
        }
        return openModal({
          type: 'Error',
          title: 'Error',
          err,
        });
      });
  };

  const cancelAction = () => removeModal(content);

  return <BaseModal onClose={cancelAction} title={'Change Password'}>
    <DescriptiveText>Change the password you use to login to CircleBlack.</DescriptiveText>
    <form id={'changePasswordForm'} onSubmit={submit}>
      <Row wrap={true}>
        <TextInput title='Old Password'
                   type='password'
                   placeholder='Enter Old Password'
                   dataPoint={{name: 'oldPassword', value: oldPassword}}
                   onChange={updateOldPassword}
                   required/>
        <CreatePassword onChange={updatePassword} dataPoint={password}/>
      </Row>
      <Row wrap={true}>
        <Button width={'auto'} importance={'primary'} size={'md'} label={'Submit'} disabled={false} action={'SUBMIT'}/>
        <Button width={'auto'} importance={'secondary'} size={'md'} label={'Cancel'} disabled={false} action={cancelAction}/>
      </Row>
    </form>
  </BaseModal>;
}

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  removeModal: modalToRemove => dispatch(_removeModal(modalToRemove)),
  setNotification: note => dispatch(_setNotification(note)),
});

export default connect(null, mapDispatchToProps)(ChangePasswordModal);

ChangePasswordModal.propTypes = {
  setNotification: PropTypes.func.isRequired,
  content: PropTypes.shape({
    /**
     * Name of the Modal given from the reducer
     */
    componentName: PropTypes.string.isRequired,
    /**
     * Modal id given from reduce
     */
    id: PropTypes.string.isRequired,
    /**
     * The items to be displayed and then approved / shared
     */
    items: PropTypes.array.isRequired,
    /**
     * Function to update the approval queue table
     */
    updateData: PropTypes.func.isRequired,
  }),
  /**
   * The open function that dispatches _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
  /**
   * The close function that dispatches _removeModal from Redux
   */
  removeModal: PropTypes.func.isRequired,
};
